<template>
  <div
    class="editor-autocomplete-container"
    :class="[`editor-autocomplete-container-${styleType}`, { 'editor-autocomplete-container-border': border }]"
  >
    <div
      v-if="title"
      class="editor-autocomplete-label"
    >
      {{ title }}
    </div>
    <el-autocomplete
      v-model="bindValue"
      :debounce="300"
      hide-loading
      :fetch-suggestions="dealWithRemoteRequest"
      :label="label"
      :value-key="valueKey"
      v-bind="$attrs"
      v-on="$listeners"
      @input="selectValue"
      @select="selectValue"
      select-when-unmatched
      :popper-class="popperClass"
      :placeholder="placeholder || '请输入'"
    >
      <template slot-scope="{ item }">
        <p
          class="editor-autocomplete-item"
          v-html="item[displayKey]"
        ></p>
      </template>
    </el-autocomplete>
  </div>
</template>
<script>
import { debounce } from '@/assets/js/util';
export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    value: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '请输入',
    },
    remoteMethodCallback: {
      type: Function,
      default: () => {},
    },
    label: {
      type: String,
      default: 'city',
    },
    valueKey: {
      type: String,
      default: 'name',
    },
    border: {
      type: Boolean,
      default: false,
    },
    styleType: {
      type: String,
      default: '',
    },
    displayKey: {
      type: String,
      default: 'highlight',
    },
    popperClass: {
      type: String,
      default: 'editor-autocomplete-popper',
    },
  },
  data() {
    return {
      isLoading: false,
      bindValue: this.value,
    };
  },
  methods: {
    requestList: debounce(async function (query, cb) {
      try {
        this.isLoading = true;
        const res = await this.remoteMethodCallback(query);
        if (res?.code === 1000) {
          cb && cb(res.data);
          const pikcerItem = res.data.find((item) => item[this.valueKey] === this.bindValue);
          if (pikcerItem) {
            this.$emit('clickPickerItem', pikcerItem);
          }
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    }, 300),
    async dealWithRemoteRequest(query, cb) {
      if (!this.remoteMethodCallback) return;
      this.requestList(query, cb);
    },
    selectValue(data) {
      this.$emit('clickPickerItem', data, 'click');
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@/assets/css/variable.scss';
.editor-autocomplete-container {
  display: flex;
  flex-direction: column;
  .editor-autocomplete-label {
    font-size: 14px;
    color: $form-label-color;
    margin-bottom: 12px;
  }
  .el-autocomplete {
    ::v-deep(.el-input),
    ::v-deep(.el-textarea) {
      .el-input__inner,
      .el-textarea__inner {
        border-color: transparent !important;
        background-color: $page-bg-sub-color;
        color: $text-color;
        &:focus,
        &:hover {
          border-color: $hover-border-color !important;
        }
        &::placeholder {
          color: $placeholder-color;
        }
      }
    }
  }
  &.editor-autocomplete-container-1 {
    .el-autocomplete {
      ::v-deep(.el-input),
      ::v-deep(.el-textarea) {
        .el-input__inner,
        .el-textarea__inner {
          background-color: $modal-input-bg1-color !important;
        }
      }
    }
  }
  &.editor-autocomplete-container-2 {
    .el-autocomplete {
      ::v-deep(.el-input),
      ::v-deep(.el-textarea) {
        .el-input__inner,
        .el-textarea__inner {
          background-color: $modal-input-bg2-color !important;
        }
      }
    }
  }
  &.editor-autocomplete-container-border {
    .el-autocomplete {
      ::v-deep(.el-input),
      ::v-deep(.el-textarea) {
        border: 1px solid $modal-input-border-color !important;
        border-radius: 6px;
      }
    }
  }
}
</style>
<style lang="scss">
@import '@/assets/css/variable.scss';
.editor-autocomplete-popper {
  background-color: transparent !important;
  border-color: $select-border-color !important;
  background: linear-gradient(45deg, $select-bg-start-color 0%, $select-bg-middle-color 62%, $select-bg-end-color 100%);
  .el-scrollbar {
    .el-autocomplete-suggestion__wrap {
      .el-autocomplete-suggestion__list {
        li {
          color: $text-color;
          .es-highlighter {
            color: $theme-color;
          }
          &.hover,
          &:hover {
            background-color: $select-dropdown-item-hover;
          }
        }
      }
    }
  }
  .popper__arrow {
    display: none;
  }
}
</style>
